import React from 'react';
import { Row } from 'reactstrap';
import TrendContainer from 'components/containers/TrendContainer';
import DonutContainer from 'components/containers/DonutContainer';
import HorizontalBarChartContainer from 'components/containers/HorizontalBarChartContainer';
import ScreenTransitionContainer from 'components/containers/ScreenTransitionContainer';
import VerticalBarChartContainer from 'components/containers/VerticalBarChartContainer';
import TableContainer from 'components/containers/TableContainer';

let page = 'portal';
let displayPageName = 'Portal';

class PortalOverview extends React.Component {
    render() {
        let dashboard = (
            <div>
                <TrendContainer
                    path={this.props.path}
                    appliedFilters={this.props.appliedFilters}
                    usageSource="Portal"
                    forceReloadTrend={this.props.forceReloadTrend}
                    forceReloadAll={this.props.forceReloadAll}
                    title="Trends"
                    workbenchTitle="trends"
                    page={page}
                    pageName={displayPageName}
                    key="portal_overview_trend_1"
                    id="portal_overview_trend_1"
                    tabFunction={this.props.tabFunction}
                    showWorkbenchLink={this.props.showWorkbench}
                    tenantIcaoCode={this.props.tenantIcaoCode}
                    subscription={this.props.subscription}
                    app={this.props.app}
                    subscriptionStage={this.props.subscriptionStage}
                />

                <Row>
                    <DonutContainer
                        path={this.props.path}
                        appliedFilters={this.props.appliedFilters}
                        renderType=""
                        donut_value="portal_device_browser"
                        page={page}
                        pageName={displayPageName}
                        forceReloadAll={this.props.forceReloadAll}
                        tabFunction={this.props.tabFunction}
                        showWorkbenchLink={this.props.showWorkbench}
                        tenantIcaoCode={this.props.tenantIcaoCode}
                        subscription={this.props.subscription}
                        app={this.props.app}
                        subscriptionStage={this.props.subscriptionStage}
                    />

                    <DonutContainer
                        path={this.props.path}
                        appliedFilters={this.props.appliedFilters}
                        renderType=""
                        donut_value="portal_device_os"
                        page={page}
                        pageName={displayPageName}
                        forceReloadAll={this.props.forceReloadAll}
                        tabFunction={this.props.tabFunction}
                        showWorkbenchLink={this.props.showWorkbench}
                        tenantIcaoCode={this.props.tenantIcaoCode}
                        subscription={this.props.subscription}
                        app={this.props.app}
                        subscriptionStage={this.props.subscriptionStage}
                    />
                </Row>

                <Row>
                    <DonutContainer
                        path={this.props.path}
                        appliedFilters={this.props.appliedFilters}
                        renderType=""
                        donut_value="passenger_engagement"
                        page={page}
                        pageName={displayPageName}
                        forceReloadAll={this.props.forceReloadAll}
                        tabFunction={this.props.tabFunction}
                        showWorkbenchLink={this.props.showWorkbench}
                        tenantIcaoCode={this.props.tenantIcaoCode}
                        allowedApps={this.props.allowedApps}
                        subscription={this.props.subscription}
                        app={this.props.app}
                        subscriptionStage={this.props.subscriptionStage}
                    />

                    <DonutContainer
                        path={this.props.path}
                        appliedFilters={this.props.appliedFilters}
                        renderType=""
                        donut_value="portal_device_type"
                        page={page}
                        pageName={displayPageName}
                        forceReloadAll={this.props.forceReloadAll}
                        tabFunction={this.props.tabFunction}
                        showWorkbenchLink={this.props.showWorkbench}
                        tenantIcaoCode={this.props.tenantIcaoCode}
                        subscription={this.props.subscription}
                        app={this.props.app}
                        subscriptionStage={this.props.subscriptionStage}
                    />
                </Row>
                <Row>
                    <HorizontalBarChartContainer
                        path={this.props.path}
                        appliedFilters={this.props.appliedFilters}
                        usageSource="Portal"
                        forceReloadAll={this.props.forceReloadAll}
                        title="Portal Browsing Pages"
                        workbenchTitle="portal_browsing_pages"
                        page={page}
                        pageName={displayPageName}
                        reportType="pages"
                        color="#2BCAB7"
                        key="portal_overview_portal_browsing_pages_1"
                        id="portal_overview_portal_browsing_pages_1"
                        tabFunction={this.props.tabFunction}
                        showWorkbenchLink={this.props.showWorkbench}
                        tenantIcaoCode={this.props.tenantIcaoCode}
                        subscription={this.props.subscription}
                        app={this.props.app}
                        subscriptionStage={this.props.subscriptionStage}
                    />

                    <HorizontalBarChartContainer
                        path={this.props.path}
                        appliedFilters={this.props.appliedFilters}
                        usageSource="Portal"
                        forceReloadAll={this.props.forceReloadAll}
                        title="Routes"
                        workbenchTitle="routes"
                        page={page}
                        pageName={displayPageName}
                        reportType="routes"
                        color="#A1C9EB"
                        routes={true}
                        key="portal_overview_routes_1"
                        id="portal_overview_routes_1"
                        tabFunction={this.props.tabFunction}
                        showWorkbenchLink={this.props.showWorkbench}
                        tenantIcaoCode={this.props.tenantIcaoCode}
                        subscription={this.props.subscription}
                        app={this.props.app}
                        subscriptionStage={this.props.subscriptionStage}
                    />
                </Row>
                <Row>
                    <ScreenTransitionContainer
                        path={this.props.path}
                        usageSource={displayPageName}
                        pageName={displayPageName}
                        page={page}
                        forceReloadAll={this.props.forceReloadAll}
                        id={'portal_overview_screen_transition'}
                        title={'Portal Screen Transitions'}
                        appliedFilters={this.props.appliedFilters}
                        showWorkbenchLink={this.props.showWorkbench}
                        tenantIcaoCode={this.props.tenantIcaoCode}
                        subscription={this.props.subscription}
                        app={this.props.app}
                        subscriptionStage={this.props.subscriptionStage}
                    />
                </Row>

                <Row>
                    <VerticalBarChartContainer
                        path={this.props.path}
                        appliedFilters={this.props.appliedFilters}
                        usageSource={displayPageName}
                        pageName={displayPageName}
                        forceReloadAll={this.props.forceReloadAll}
                        showWorkbenchLink={this.props.showWorkbench}
                        tenantIcaoCode={this.props.tenantIcaoCode}
                        title={'Passenger Interaction Timeline'}
                        page={page}
                        subscription={this.props.subscription}
                        app={this.props.app}
                        subscriptionStage={this.props.subscriptionStage}
                    />
                </Row>

                <Row>
                    <TableContainer
                        pageName={displayPageName}
                        tenantIcaoCode={this.props.tenantIcaoCode}
                        data={this.props.data}
                        dataset={this.props.dataset}
                        loading={this.props.loading}
                        appliedFilters={this.props.appliedFilters}
                        app={this.props.app}
                        title="Portal"
                    />
                </Row>
            </div>
        );

        return <div>{dashboard}</div>;
    }
}

export default PortalOverview;
